import { Fragment } from 'react';
import { Result } from 'antd';
import classnames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import Layout from '../Layout';
import EmptyState from './empty-state.svg';
import s from './NotFound.module.less';

const NotFound = ({ isTransientPage = false }) => {
  const flags = useFlags();

  const { t } = useTranslation('common');
  const tl = msg => t(`notFound.${msg}`);
  const msg = isTransientPage ? tl('message.transient') : tl('message.default');
  const subTitle = isTransientPage ? tl('subtitle.transient') : tl('subtitle.default');
  const extra = (
    <div className={classnames([s.extra])}>
      <span>{msg}</span>
    </div>
  );

  const Wrapper = flags['search-redesign'] ? Layout : Fragment;
  const wrapperProps = flags['search-redesign']
    ? { showFooter: false, containerClassName: s.outerWrapper }
    : {};

  return (
    <Wrapper {...wrapperProps}>
      {flags['update-empty-state'] ? (
        <div className={s.wrapper}>
          <EmptyState />
          <h3>{subTitle}</h3>
          <p>{msg}</p>
        </div>
      ) : (
        <div className={classnames([s.container])}>
          <Result status="404" title="Error 404" subTitle={subTitle} extra={extra}></Result>
        </div>
      )}
    </Wrapper>
  );
};

export default NotFound;
